<template>
  <div>
    <v-select
      :value="value"
      :items="roleItems"
      item-text="label"
      item-value="key"
      item-disabled="disabled"
      :label="$t('accessRoles.choose')"
      :loading="loading"
      :disabled="disabled"
      outlined
      dense
      hide-details="auto"
      @input="$emit('input', $event)"
    >
    </v-select>

    <div v-if="selectedRole" class="mt-3">
      <div class="subtitle-2 mb-2">{{ $t("accessRoles.matrix") }}</div>
      <div class="access-grid">
        <div v-for="module in modules" :key="module" class="access-row">
          <span class="access-module">
            {{ $t(`accessRoles.modules.${module}`) }}
          </span>
          <v-chip
            x-small
            label
            :color="levelColor(selectedRole.access[module].level)"
            :outlined="selectedRole.access[module].level === '-'"
            :dark="selectedRole.access[module].level !== '-'"
          >
            {{ $t(`accessRoles.levels.${selectedRole.access[module].level}`) }}
            <template v-if="selectedRole.access[module].restriction">
              ·
              {{
                $t(
                  `accessRoles.restrictions.${selectedRole.access[module].restriction}`
                )
              }}
            </template>
          </v-chip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const MODULE_ORDER = [
  "riskAssessment",
  "tickets",
  "dangerousGoods",
  "medkitlog",
  "incidentReport",
  "environmentalReport",
  "managedInstruction",
  "operatingInstruction",
  "inspection",
  "examination",
  "proof",
  "documents",
  "users",
  "settings",
];

export default {
  name: "accessRolePicker",
  props: {
    value: { type: String, default: null },
    disabled: { type: Boolean, default: false },
  },
  data: () => ({
    roles: [],
    loading: false,
  }),
  computed: {
    modules() {
      return MODULE_ORDER;
    },
    roleItems() {
      return this.roles.map((role) => ({
        key: role.key,
        label: this.$t(`accessRoles.roles.${role.key}`),
        disabled: !role.assignable && role.key !== this.value,
      }));
    },
    selectedRole() {
      return this.roles.find((role) => role.key === this.value) || null;
    },
  },
  async created() {
    this.loading = true;
    try {
      this.roles = await this.$store.dispatch("getAccessRoles");
    } finally {
      this.loading = false;
    }
  },
  methods: {
    levelColor(level) {
      return (
        {
          A: "deep-purple",
          V: "green darken-1",
          B: "blue darken-1",
          E: "orange darken-2",
          L: "blue-grey",
          "-": "grey",
        }[level] || "grey"
      );
    },
  },
};
</script>

<style scoped>
.access-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 4px 16px;
}
.access-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  font-size: 0.875rem;
}
.access-module {
  margin-right: 8px;
}
</style>
